<script setup lang="ts">
defineProps<{
    moreInfoOpen: boolean;
    premiumId: number;
}>();

defineEmits<{
    click: [premiumId: number]
}>();
</script>

<template>
    <button
        :id="'btn-more-info_' + premiumId"
        type="button"
        :aria-expanded="moreInfoOpen"
        :aria-controls="'premium-details_' + premiumId"
        class="col-12 col-sm-10 col-lg-8 col-xl-12 mx-auto more_info btn btn-info mt-4 mt-lg-1 mb-3 middle collapsed"
        @click="$emit('click', premiumId)"
    >
        {{ moreInfoOpen ? "Hide Info" : "More Info" }}
    </button>
</template>
